import axios from 'axios';
import axiosBetterStacktrace from 'axios-better-stacktrace';
import { setupCache } from 'axios-cache-adapter';
import formurlencoded from 'form-urlencoded';
import _ from 'underscore';
import { drainFeatureUsageHeader, FEATURE_USAGE_HEADER, isSaveProductRequest } from '@/utils/featureUsage';

// Create `axios-cache-adapter` instance
const cache = setupCache({
    maxAge: 0, // Control cache age on each request
    exclude: {
        // Don't exclude requests with query parameters
        query: false
    }
});

const axiosInstance = axios.create({
    baseURL: 'api',
    responseType: 'json',
    adapter: cache.adapter
});
axiosInstance.interceptors.request.use((config) => {
    config.params = config.params || {};

    /**
     * Before anything else, Safari, bite me. This is a workaround for a bug in Safari where if you make a request
     *  to the exactly same URL multiple times one after the other, Safari will only make the first request and the response
     *  to all others will be the result of the first one, you can't even see the requests in the network tab!! Useful links:
     *  https://www.raymondcamden.com/2015/07/16/safari-and-http-caching
     *  https://bugs.webkit.org/show_bug.cgi?id=147022
     */
    config.params.cacheKey = _.random(Number.MAX_SAFE_INTEGER);

    // Feature-usage telemetry rides its own save rather than the payload; see utils/featureUsage.ts
    if (isSaveProductRequest(config.url)) {
        const featureUsage = drainFeatureUsageHeader();
        if (featureUsage) {
            config.headers = { ...config.headers, [FEATURE_USAGE_HEADER]: featureUsage };
        }
    }

    return config;
});
axiosBetterStacktrace(axiosInstance);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toUrlEncoded = (data: { [key: string]: any }): string => {
    return formurlencoded(data);
};

export const toUriEncoded = (uri: string): string => {
    return encodeURIComponent(encodeURIComponent(uri));
};

export default axiosInstance;
